import { useState, createContext } from 'react';
import { api } from '@/utils/api';
import { useEventListener } from '@/hooks';

const defaultContext = {
  loaded: false,
  loading: false,
  events: [],
};

export const ConsentStateContext = createContext(defaultContext);

export function useConsentStateContext() {
  const [context, setContext] = useState({
    loaded: !!api.consent.consentState,
    loading: !!api.consent.consentState,
    events: api?.consent?.consentState || [],
  });
  useEventListener(api.consent.events.ConsentStateLoading, () =>
    setContext((prevContext) => ({ ...prevContext, loading: true })),
  );
  useEventListener(api.consent.events.ConsentStateLoaded, () => {
    setContext((prevContext) => ({
      ...prevContext,
      loaded: true,
      loading: false,
      events: api.consent.consentState,
    }));
  });
  useEventListener(api.consent.events.ConsentStateChanged, () => {
    setContext((prevContext) => ({
      ...prevContext,
      events: api.consent.consentState,
    }));
  });

  return {
    ...context,
  };
}
